import { doFetch } from "./ConnectionManager";

export const PORTAL_ITEM_TYPES = Object.freeze({
  ROADMAP: "TAREA_ROADMAP",
  DECISION: "DECISION",
});

export const ROADMAP_STATUSES = Object.freeze([
  { value: "PENDING", label: "Pendiente" },
  { value: "PREPARED", label: "Preparado" },
  { value: "IN_PROGRESS", label: "En curso" },
  { value: "IN_REVIEW", label: "En revisión" },
  { value: "BLOCKED", label: "Bloqueado" },
  { value: "VERIFIED", label: "Verificado" },
]);

export class PortalHttpError extends Error {
  constructor(status, message) {
    super(message || "No se pudo consultar el portal");
    this.name = "PortalHttpError";
    this.status = Number(status || 0);
  }
}

async function readPortalResponse(response) {
  if (!response) throw new PortalHttpError(0, "El servicio del portal no está disponible");
  const body = await response.json().catch(() => null);
  if (!response.ok) throw new PortalHttpError(response.status, body?.MESSAGE || body?.message);
  return body?.DATA ?? body ?? null;
}

function addFilter(params, key, value) {
  const normalized = value == null ? "" : String(value).trim();
  if (normalized) params.set(key, normalized);
}

export async function getPortalItems({ type, project, status, search } = {}) {
  const params = new URLSearchParams();
  addFilter(params, "type", type);
  addFilter(params, "project", project);
  addFilter(params, "status", status);
  addFilter(params, "search", search);
  const suffix = params.toString() ? "?" + params.toString() : "";
  const response = await doFetch("CUBE", "portal/items" + suffix, { method: "GET", _silent: true });
  const data = await readPortalResponse(response);
  return Array.isArray(data) ? data : [];
}

export async function getCubeCapabilities() {
  const response = await doFetch("CUBE", "portal/capabilities", { method: "GET", _silent: true });
  const data = await readPortalResponse(response);
  return normalizeCubeCapabilities(data);
}

export function normalizeCubeCapabilities(data = {}) {
  return Object.freeze({
    applications: true,
    users: data?.users === true,
    incidents: data?.incidents === true,
    development: data?.development === true,
    maintenance: data?.maintenance === true,
    maintenanceProcesses: data?.maintenanceProcesses === true,
    operationsDocuments: data?.operationsDocuments === true,
    portal: data?.portal === true,
    appAdmin: data?.appAdmin === true,
  });
}

export async function getPortalDocuments({ project, classification, search } = {}) {
  const params = new URLSearchParams();
  addFilter(params, "project", project);
  addFilter(params, "class", classification);
  addFilter(params, "search", search);
  const suffix = params.toString() ? "?" + params.toString() : "";
  const response = await doFetch("CUBE", "portal/documents" + suffix, { method: "GET", _silent: true });
  const data = await readPortalResponse(response);
  return Array.isArray(data) ? data : [];
}

export async function getPortalDocument(id) {
  const normalized = String(id == null ? "" : id).trim();
  if (!normalized) throw new PortalHttpError(400, "Identificador de documento no válido");
  const response = await doFetch("CUBE", "portal/documents/" + encodeURIComponent(normalized), {
    method: "GET",
    _silent: true,
  });
  return readPortalResponse(response);
}
